import React from "react";

import { faMinus, faPlus } from "@performyard/fontawesome/pro-regular-svg-icons";
import { ButtonIcon, Text } from "@performyard/py-components";

type AccordionSectionHeaderProps = {
	title: string;
	isExpanded: boolean;
	onToggle: () => void;
	isCollapsible?: boolean;
};

const AccordionSectionHeader = ({
	title,
	isExpanded,
	onToggle,
	isCollapsible = true,
}: AccordionSectionHeaderProps): React.ReactElement => {
	return (
		<div
			className={`sticky top-0 z-10 flex h-12 select-none items-center justify-between bg-neutral-1 px-4 ${
				isCollapsible ? "cursor-pointer hover:bg-neutral-2" : ""
			}`}
			onClick={isCollapsible ? onToggle : undefined}
		>
			<Text size="paragraph-2" weight="semi-bold">
				{title}
			</Text>
			{isCollapsible ? <ButtonIcon icon={isExpanded ? faMinus : faPlus} color="neutral-7" /> : null}
		</div>
	);
};

export default AccordionSectionHeader;
